import $ from "jquery";

export function initArrows(): void {
    $('.dropdown-toggle').each(function () {
        if ($(this).find('.arrow').length === 0) {
            $(this).append("<div class='arrow arrow--smallest arrow--down arrow--white ms-2'><span></span><span></span></div>");
        }
    });

    $(".dropdown-toggle").on("click", function () {
        $(this).children(".arrow").toggleClass("active");
        $(".dropdown-toggle").not(this).children(".arrow").removeClass("active");
    });

    $(document).on("mouseup", (e) => {
        const $mainmenu = $(".dropdown");
        if (!$mainmenu.is(e.target as unknown as Element) && $mainmenu.has(e.target as unknown as Element).length === 0) {
            $(".dropdown-toggle").children(".arrow").removeClass("active");
        }
    });
}
